module.exports = __webpack_public_path__ + "img/horizontal_4_3_5012.3b7dc584.png";